import { render, staticRenderFns } from "./rf_price.vue?vue&type=template&id=66febd5e&scoped=true&"
import script from "./rf_price.vue?vue&type=script&lang=js&"
export * from "./rf_price.vue?vue&type=script&lang=js&"
import style0 from "./rf_price.vue?vue&type=style&index=0&id=66febd5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66febd5e",
  null
  
)

export default component.exports